
















import Vue from 'vue'
import { Snackbar } from '@raksul/raksul-common-ui'
import { SnackbarModel } from '@/common/types'

export default Vue.extend({
  components: { Snackbar },
  props: {
    messages: {
      type: Array as () => SnackbarModel[],
      required: true
    }
  },
  methods: {
    onConfirm(id: string) {
      this.$emit('confirm', id)
    }
  }
})
